import React, {useContext, useEffect, useState} from "react";

import {ButtonGroup, Card, Chip} from "@mui/material";
import MDBox from "../../components/MDBox";
import Grid from "@mui/material/Grid";
import 'ckeditor5/ckeditor5.css';
import Meta from "../common/Meta";
import ContextSearchNavbar from "../navbars/ContextSearchNavbar";
import Footer from "../Footer";
import DashboardLayout from "../LayoutContainers/DashboardLayout";
import {getCafeFulfilledOrders, getCafeOrders, getCafeOrderStatuses, updateCafeOrder} from "../common/api/WebApi";
import {formatCurrency, formatDateTime} from "../common/Utils";
import {AppContext} from "../../lib/AppContext";
import MDButton from "../../components/MDButton";
import {CONSTANTS} from "../common/constants";
import Avatar from "@mui/material/Avatar";
import Icon from "@mui/material/Icon";
import Loading from "../common/Loading";
import {printOrder} from "../common/api/CustomerProfileApi";
import CafeOrderOptionItem from "./CafeOrderOptionItem";

export default function CafeOrders({callback}) {
  const [context, setContext] = useContext(AppContext);

  const [manageTask, setManageTask] = useState(false);
  const [currentTask, setCurrentTask] = useState();
  const [tasks, setTasks] = useState();
  const [confirmation, setConfirmation] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [saving, setSaving] = useState(false);

  const [ordersReady, setOrdersReady] = useState(false);

  const [orders, setOrders] = useState([]);
  const [fulfilledOrders, setFulfilledOrders] = useState([]);
  const [newItemFlag, setNewItemFlag] = useState(false);
  const [orderStatuses, setOrderStatuses] = useState([]);

  useEffect(() => {
    getCafeOrderStatuses().then((resp) => {
      setOrderStatuses(resp);
    });
    getFulfilledOrdersFn();
  }, []);

  const bloop = 'https://cdn.playspacebrain.com/assets/psb-bloop.mp3';
  const ploop = 'https://cdn.playspacebrain.com/assets/psb-ploop.mp3';

  const [audio, setAudio] = useState(new Audio(bloop));
  const [playing, setPlaying] = useState(false);

  const toggle = () => setPlaying(!playing);
  const [hasInteracted, setHasInteracted] = useState(false);

  useEffect(() => {
      playing ? audio.play() : audio.pause();
    },
    [playing, audio]
  );

  useEffect(() => {
    const handleInteraction = () => {
      setHasInteracted(true);
    };

    // Add listeners for various interactions
    window.addEventListener('click', handleInteraction, {once: true});
    window.addEventListener('keydown', handleInteraction, {once: true});
    window.addEventListener('touchstart', handleInteraction, {once: true});

    return () => {
      window.removeEventListener('click', handleInteraction);
      window.removeEventListener('keydown', handleInteraction);
      window.removeEventListener('touchstart', handleInteraction);
    };
  }, [audio]);


  useEffect(() => {
    audio.addEventListener('ended', () => setPlaying(false));
    return () => {
      audio.removeEventListener('ended', () => setPlaying(false));
    };
  }, [audio]);


  useEffect(() => {
    if (newItemFlag) {
      let _context = {...context};
      _context.toast = {
        message: 'New Order Received!',
      }
      setContext({..._context});
      if (hasInteracted) {
        if (newItemPloopFlag) {
          setAudio(new Audio(ploop))
        } else {
          setAudio(new Audio(bloop))
        }
        setPlaying(true);
      }
    }
  }, [newItemFlag]);

  const getFulfilledOrdersFn = () => {
    getCafeFulfilledOrders().then((resp) => {
      setFulfilledOrders(resp);
    })
  }

  const updateOrderStatus = (order, status) => {
    let _o = {...order};
    _o.orderStatus = status;
    let _orders = [...orders];
    for (let j in _orders) {
      if (order.orderGk === _orders[j].orderGk) {
        _orders[j].orderStatus = status;
        _orders[j].acting = true;
      }
    }
    setOrders(_orders);
    updateCafeOrder(_o).then(r => {
      refreshCafeOrdersFn();
      if (order.orderStatus.id === 4) {
        getFulfilledOrdersFn();
      }
    })
  }

  const refreshCafeOrdersFn = async () => {
    getCafeOrders().then((resp) => {
      setOrders(resp);
    })
  }

  const OrderDetails = ({order, fulfilled}) => {
    return (<>

      <p style={{
        fontSize: '0.85rem',
        lineHeight: '0.9rem'
      }}>
        <b>Quantity</b>&nbsp;{order?.quantity}
      </p>

      {order?.inventory?.cafeOptions?.length > 0 && <>
        {order?.inventory?.cafeOptions?.sort((a, b) => a.sortOrder - b.sortOrder).map((opt, idx) => {
          return (
            <CafeOrderOptionItem key={idx} option={opt} />
          )
        })
        }
      </>}
      {!fulfilled && <>
        <ButtonGroup className="no-print" variant="contained" aria-label="Order Status" style={{
          position: 'absolute',
          bottom: '0',
          left: '0',
          maxWidth: '100%',
          opacity: order.acting ? '0.2' : '1'
        }}>
          {orderStatuses?.sort((a, b) => a.id - b.id).map((status, idx) => {
            return (<MDButton
              size={"small"}
              color={"info"}
              onClick={() => {
                updateOrderStatus(order, status)
              }}
              key={idx}
              disabled={status.id === CONSTANTS.ORDER_STATUS.TAB}
              style={{
                border: 'solid 1px #000',
                backgroundColor: status.id === order?.orderStatus?.id ? '#111' : '#fff',
                color: status.id === order?.orderStatus?.id ? '#fff' : '#111',
              }}>{status.name}</MDButton>)
          })
          }
        </ButtonGroup>
      </>
      }

    </>)
  }

  const [newItemPloopFlag, setNewItemPloopFlag] = useState(false);

  const getCafeOrdersFn = async () => {
    getCafeOrders().then((resp) => {
      setOrdersReady(true);
      setOrders(prevOrders => {
        const prevKeys = prevOrders.map(order => order.orderGk);
        const newItems = resp.filter(order => !prevKeys.includes(order.orderGk));
        setNewItemPloopFlag(false);
        if (newItems.length > 0) {
          for (let j in newItems) {
            if (newItems[j].createUser?.userTypeId !== CONSTANTS.USER_TYPE.EMPLOYEE) {
              setNewItemPloopFlag(true);
            }
          }
          setNewItemFlag(true);
          setTimeout(() => setNewItemFlag(false), 1000);
        }

        // Merge and sort by createdAt (or whatever your sort field is)
        const merged = [...prevOrders, ...newItems];

        return merged.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      });
    })
  }

  useEffect(() => {
    getCafeOrdersFn(); // fetch once on mount

    const intervalId = setInterval(() => {
      getCafeOrdersFn(); // fetch every 30 seconds
    }, 30000);

    return () => clearInterval(intervalId); // cleanup on unmount
  }, []);

  const printCafeOrderTerminal = (extOrderId) => {
    printOrder(extOrderId).then((resp) => {
      let _context = {...context};
      _context.toast = {
        message: 'See Printer For Confirmation',
      }
      setContext({..._context});
    })
  }

  const printCafeOrder = (divId) => {
    const content = document.getElementById(divId).innerHTML;
    const printWindow = window.open('', '', 'width=800,height=600');
    printWindow.document.write(`
                                              <html>
                                              <head>
                                                  <title>Print</title>
                                                  <style>
                                                      body { font-family: Arial, sans-serif; padding: 20px; font-size:0.9rem; line-height:0.9rem; }
                                                      p{margin:0; padding:0; line-height:13px; font-size:12px;}
                                                      h1,h2,h3,h4,h5,h6{font-size:14px; margin:0; padding:0; line-height:15px}
                                                      .no-print { display: none !important; }
                                                  </style>
                                              </head>
                                              <body onload="window.print(); window.close();">
                                                   ${content}
                                              </body>
                                              </html>
                                            `);
    printWindow.document.close();
  }

  return (
    <DashboardLayout>

      <Meta pageTitle={'Cafe Orders'}/>

      <ContextSearchNavbar title="Cafe Orders"/>

      <MDBox py={3}>
        <MDBox mb={3}>

          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Card>
                <MDBox p={2}>

                  <MDBox p={1} my={2}>

                    <Grid container spacing={2}>
                      {!ordersReady && orders?.length === 0 && <>
                        <Grid item xs={12}>
                          <Loading/>
                        </Grid>
                      </>
                      }
                      {ordersReady && orders?.length === 0 && <>
                        <Grid item xs={12}>
                          <center>No orders yet</center>
                        </Grid>
                      </>
                      }
                      {orders?.length > 0 && <>
                        {orders?.sort((a, b) => new Date(a.createDate).getTime() - new Date(b.createDate).getTime()).map((order, idx) => {
                          return (
                            <Grid item xs={12} md={6} lg={4} key={idx}>
                              <div id={`cafe-order-${order.orderGuid}`} style={{
                                border: 'solid 1px #ddd',
                                height: '100%',
                                position: 'relative',
                                padding: '10px 10px 60px 10px',
                                background: order?.createUser?.userTypeId === CONSTANTS.USER_TYPE.EMPLOYEE ? 'inherit' : '#FBF7EE'
                              }}>
                                <h5 style={{
                                  marginBottom: '2px'
                                }}>{order?.inventory?.name}
                                  {order?.extPurchaseId &&
                                    <Avatar
                                      className={'no-print'}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        printCafeOrderTerminal(order.extPurchaseId);
                                      }}
                                      style={{
                                        height: '45px',
                                        width: '45px',
                                        background: '#fff',
                                        float: 'right',
                                        border: 'solid 1px #B1B1B1FF',
                                        borderRadius: '50px',
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        margin: '-18px -18px 0 0',
                                      }}><span className={'fa fa-print'} style={{
                                      fontSize: '14px',
                                      color: '#111'
                                    }}></span></Avatar>
                                  }
                                  {Math.ceil(new Date().getTime() - new Date(order.createDate).getTime()) / 1000 / 60 <= 10 ?
                                    <span className={'no-print'}>
                                      <Chip
                                        style={{
                                          marginRight: '2px',
                                          float: 'right'
                                        }}
                                        avatar={<Avatar><Icon>verified</Icon></Avatar>}
                                        color={
                                          CONSTANTS.CHIP_COLORS[order?.orderStatus.id]
                                        } label={'New ' + order?.orderStatus?.name}/>
                                    </span>
                                    : <span className={'no-print'}>
                                      <Chip
                                        style={{
                                          marginRight: '4px',
                                          float: 'right'
                                        }}
                                        color={
                                          CONSTANTS.CHIP_COLORS[order?.orderStatus.id]
                                        } label={order?.orderStatus?.name}/>
                                    </span>}


                                </h5>

                                <h6>
                                  {order?.customer?.userTypeId === CONSTANTS.USER_TYPE.EMPLOYEE && <>
                                    {order?.guestName || 'Guest'}
                                  </>}
                                  {order?.customer?.userTypeId !== CONSTANTS.USER_TYPE.EMPLOYEE && <>
                                    <a href={`/client/${order?.customer?.guid}`} target={"_blank"}>
                                      {order?.customer?.firstName} {order?.customer?.lastName}
                                    </a>
                                  </>}

                                </h6>

                                <p style={{
                                  fontSize: '0.85rem',
                                  lineHeight: '0.9rem',
                                  margin: 0,
                                  padding: 0,
                                }}><small>Ordered: {formatDateTime(order?.createDate)}</small></p>
                                <p style={{
                                  fontSize: '0.85rem',
                                  lineHeight: '0.9rem'
                                }}><small>Last Updated: {formatDateTime(order?.modifyDate)}</small></p>

                                <div style={{
                                  marginTop: '8px'
                                }}>

                                  <OrderDetails order={order}/>

                                </div>
                              </div>

                            </Grid>
                          )
                        })
                        }
                      </>
                      }
                    </Grid>
                  </MDBox>
                </MDBox>
              </Card>

              {fulfilledOrders?.length > 0 && <Card className={'mt-2'}>
                <MDBox p={2}>
                  <h5>Completed orders today</h5>
                  <table className={'table table-striped'}>
                    <thead>
                    <tr>
                      <th><small>Order</small></th>
                      <th><small>Customer</small></th>
                      <th><small>Updated</small></th>
                      <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    {fulfilledOrders?.sort((a, b) => new Date(b.modifyDate).getTime() - new Date(a.modifyDate).getTime()).map((order, idx) => {
                      return (
                        <tr key={idx}>
                          <td width={"40%"}>{order?.inventory?.name}
                            <OrderDetails order={order} fulfilled={true}/>
                          </td>
                          <td>
                            {order?.customer?.userTypeId === CONSTANTS.USER_TYPE.EMPLOYEE && <>
                              {order?.guestName || 'Guest'}
                            </>}
                            {order?.customer?.userTypeId !== CONSTANTS.USER_TYPE.EMPLOYEE && <>
                              <a href={`/client/${order?.customer?.guid}`} target={"_blank"}>
                                {order?.customer?.firstName} {order?.customer?.lastName}{order?.tabItem && ' (Tab)'}
                              </a>
                            </>}
                          </td>
                          <td>{order?.orderStatus?.name} at {formatDateTime(order?.modifyDate)}</td>
                          <td width={"5%"}>
                            {order.extPurchaseId && <MDButton
                              variant="outlined"
                              color="secondary"
                              circular
                              iconOnly
                              className={'m-chip'}
                              onClick={(e) => {
                                printCafeOrderTerminal(order.extPurchaseId);
                              }}
                            >
                              <Icon>print</Icon>
                            </MDButton>
                            }
                          </td>
                        </tr>
                      )
                    })
                    }
                    </tbody>
                  </table>
                </MDBox>
              </Card>
              }

            </Grid>
          </Grid>
        </MDBox>
      </MDBox>

      <Footer mt={5}/>

    </DashboardLayout>
  );
}